import { render, staticRenderFns } from "./industry-detail.vue?vue&type=template&id=3bf29a15&scoped=true&"
import script from "./industry-detail.vue?vue&type=script&lang=js&"
export * from "./industry-detail.vue?vue&type=script&lang=js&"
import style0 from "./industry-detail.vue?vue&type=style&index=0&id=3bf29a15&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf29a15",
  null
  
)

export default component.exports